export default __webpack_public_path__ + "static/media/hema.d9e19f20.jpg";